import styled from 'styled-components';
import {themes} from "./Themes";

export const StyledErrorMsg = styled.div `
  color: ${themes.colorCodes.lightGrey};
  margin: 30px 0;
  
  
`